import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';
export const getMailboxMessages = ({
  limit,
  // oldPage,
  page,
  teamID,
  type,
  box
}) => {
  return api.get(URLS.mailboxMessages, {
    params: {
      limit,
      page,
      // oldPage,
      teamID,
      type,
      box
    },
    headers: {
      needsToken: true
    }
  });
};

export const getMailboxMessageByID = (messageID, teamID) => {
  return api.get(URLS.mailboxMessage, {
    params: {
      id: messageID,
      ...(teamID && { teamID: teamID })
    },
    headers: {
      needsToken: true
    },
    responseType: 'arraybuffer'
  });
};

export const getJobTitlesList = (query) => {
  return api.get(URLS.jobTitles, {
    params: {
      ...(query && { query: query })
    },
    headers: {
      needsToken: true
    }
  });
};

export const getSearchMailAddress = (search, orderID) => {
  return api.get(URLS.searchMailAddress, {
    params: {
      ...(search && { query: search }),
      ...(orderID && { orderID: orderID })
    },
    headers: {
      needsToken: true
    }
  });
};

export const composeEmail = (emailData) => {
  return api.post(URLS.composeEmail, emailData, {
    headers: {
      needsToken: true
    }
  });
};

export const getMailboxMessageForward = (messageID, offset) => {
  return api.get(URLS.mailboxMessageForward, {
    params: {
      id: messageID,
      offset: offset
    },
    headers: {
      needsToken: true
    },
    responseType: 'arraybuffer'
  });
};

export const forwardEmail = (mailFormData) => {
  return api.post(URLS.forwardEmail, mailFormData, {
    headers: {
      needsToken: true
    }
  });
};

export const replyEmail = (mailFormData) => {
  return api.post(URLS.replyEmail, mailFormData, {
    headers: {
      needsToken: true
    }
  });
};

export const getReplyRecipients = (id, teamID) => {
  return api.get(URLS.replyRecipients, {
    params: {
      id: id,
      teamID: teamID
    },
    headers: {
      needsToken: true
    }
  });
};

export const toggleArchiveEmailComment = (
  id,
  archiveStatus,
  type,
  feModifiedTime
) => {
  return api.post(
    URLS.archiveEmailComment,
    {
      id: id,
      archive: archiveStatus,
      type: type,
      feModifiedTime: feModifiedTime
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const updateEmailMetadata = (emailMetaData) => {
  return api.put(URLS.emailMetadata, emailMetaData, {
    headers: {
      needsToken: true
    }
  });
};

export const getEmailComment = (id) => {
  return api.get(URLS.emailComment, {
    params: {
      id: id
    },
    headers: {
      needsToken: true
    }
  });
};

export const markRead = (id) => {
  return api.post(
    URLS.markRead,
    {
      id: id
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getDefaultSubjectLine = (id) => {
  return api.get(URLS.defaultSubjectLine, {
    params: {
      id: id
    },
    headers: {
      needsToken: true
    }
  });
};
